module.exports = require("core-js/modules/es.array.some.js");